import React, { useState } from 'react';
import { trackEvent } from 'utils/google-tag-manager';
import { ExperimentVariants } from 'utils/types';
import Button from 'components/control/button';
import Listing from 'data/listing';
import { useRouter } from 'next/router';
import Image from 'next/image';
import styles from './SoldListingExperimentCard.module.scss';
import HomeAppraisalConnectionRequest from 'components/home-appraisal-connection-request';
import { buildClassName } from 'utils/build-class-name';
import { useThemeContext } from 'contexts';
import { ThemeNames } from 'types/themes';

interface Props {
  mode: ExperimentVariants;
  listing: Listing;
}

export default function SoldListingExperimentCard({ mode, listing }: Props) {
  const [showPVRForm, setShowPVRForm] = useState(false);
  const { themeName } = useThemeContext();
  const isExpTheme = themeName !== ThemeNames.ZOOCASA;
  const router = useRouter();

  const handleClickVariantA = () => {
    trackEvent('XpA_AddressOnlineEstButClk');
    router.push('/home-appraisal');
  };

  const handleTogglePVRForm = () => {
    trackEvent('XpB_AddressOfflineEstButClk');
    setShowPVRForm(true);
  };

  return (
    <div className={buildClassName(styles.component, showPVRForm && styles['no-padding'])}>
      {(mode == ExperimentVariants.A) && (
        <div className={styles.container}>
          <Image src={`/next/assets/images/sold-listings/get-estimate${isExpTheme ? '-exp' : ''}.png`} width={163} height={130} alt="For Sale" />
          <div className={styles.description}>
            <h3>How much is your home worth?</h3>
          </div>
          <Button theme='primary' label="Get a Free Online Estimate" onClick={handleClickVariantA} />
        </div>
      )}
      {(mode == ExperimentVariants.B && !showPVRForm) && (
        <div className={styles.container}>
          <Image src={`/next/assets/images/sold-listings/get-estimate${isExpTheme ? '-exp' : ''}.png`} width={163} height={130} alt="For Sale" />
          <div className={styles.description}>
            <h3>Curious about your home's value?</h3>
          </div>
          <Button theme='primary' label="Get a Home Estimate for Free" onClick={handleTogglePVRForm} />
        </div>
      )}
      {(mode == ExperimentVariants.B && showPVRForm) && (
        <HomeAppraisalConnectionRequest listing={listing} />
      )}
    </div>
  );
}